var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[(_vm.gconf.ui.home_setting == 'LMS')?_c('LmsDashboard'):(_vm.gconf.ui.home_setting == 'Dashboard')?_c('Dashboard'):_vm._e(),_c('div',{staticClass:"inner-wrap"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }